import { createContext } from 'react'

const DarkModeContext = createContext('dark')

export default DarkModeContext
